import { Formik, Form, Field, FieldArray, useFormikContext, useField, ErrorMessage } from 'formik';
import React, { useState, useEffect } from 'react';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { date } from 'yup/lib/locale';
import Select from 'react-select'
import * as AiIcons from 'react-icons/ai';
import * as Yup from 'yup'
import swal from '@sweetalert/with-react';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';

function OhsmsStage2AuditReport() {
    const history = useHistory();
    const [leadauditorList, setLeadauditorList] = useState([{
            label: "",
            value: ""
    }])
    const [assitAuditorList, setassitAuditorList] = useState([{
            label: "",
            value: ""
    }])
    const [technicalExpertList,setTechnicalExpertList] = useState([{
            label:"",
            value:""
    }])
    const options = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    const yesNo = [
        { key: 'Select', value: '-' },
        { key: 'C', value: 'C' },
        { key: 'NC', value: 'NC' },
        { key: 'O', value: 'O' },
    ]
    const [initialValues, setInitialValues] = useState({
        id: "",
        orgCode: 0,
        address:"",
        siteofaddress:"",
        total:"",
        mobile:"",
        email:"",
        contactPersonName:"",
        scope:"",
        stageOneAudit:"",
        auditdate1:new Date(),
        stageTwoAudit:"",
        auditdate2:new Date(),
        dateofaudit:new Date(),
        dateofauditto:new Date(),
        auditobjective:"",
        briefaboutorg:"",
        areqquatedmandays:"",
        istherechangeemployee:"",
        istherechangescope:"",
        isthereanyinforevent:"",
        teamleader: "",
        teamleaderName: "",
        auditorOne: "",
        auditorOneName: "",
        auditorTwo: "",
        auditorTwoName: "",
        technicalexpert: "",
        auditcheckliststatustwoohsms1:"C",
        remarkauditchecklisttwoohsms1:"",
        auditcheckliststatustwoohsms2:"C",
        remarkauditchecklisttwoohsms2:"",
        auditcheckliststatustwoohsms3:"C",
        remarkauditchecklisttwoohsms3:"",
        auditcheckliststatustwoohsms4:"C",
        remarkauditchecklisttwoohsms4:"",
        auditcheckliststatustwoohsms5:"C",
        remarkauditchecklisttwoohsms5:"",
        auditcheckliststatustwoohsms6:"C",
        remarkauditchecklisttwoohsms6:"",
        auditcheckliststatustwoohsms7:"C",
        remarkauditchecklisttwoohsms7:"",
        auditcheckliststatustwoohsms8:"C",
        remarkauditchecklisttwoohsms8:"",
        auditcheckliststatustwoohsms9:"C",
        remarkauditchecklisttwoohsms9:"",
        auditcheckliststatustwoohsms10:"C",
        remarkauditchecklisttwoohsms10:"",
        auditcheckliststatustwoohsms11:"C",
        remarkauditchecklisttwoohsms11:"",
        auditcheckliststatustwoohsms12:"C",
        remarkauditchecklisttwoohsms12:"",
        auditcheckliststatustwoohsms13:"C",
        remarkauditchecklisttwoohsms13:"",
        auditcheckliststatustwoohsms14:"C",
        remarkauditchecklisttwoohsms14:"",
        auditcheckliststatustwoohsms15:"C",
        remarkauditchecklisttwoohsms15:"",
        auditcheckliststatustwoohsms16:"C",
        remarkauditchecklisttwoohsms16:"",
        auditcheckliststatustwoohsms17:"C",
        remarkauditchecklisttwoohsms17:"",
        auditcheckliststatustwoohsms18:"C",
        remarkauditchecklisttwoohsms18:"",
        auditcheckliststatustwoohsms19:"C",
        remarkauditchecklisttwoohsms19:"",
        auditcheckliststatustwoohsms20:"C",
        remarkauditchecklisttwoohsms20:"",
        auditcheckliststatustwoohsms21:"C",
        remarkauditchecklisttwoohsms21:"",
        auditcheckliststatustwoohsms22:"C",
        remarkauditchecklisttwoohsms22:"",
        auditcheckliststatustwoohsms23:"C",
        remarkauditchecklisttwoohsms23:"",
        auditcheckliststatustwoohsms24:"C",
        remarkauditchecklisttwoohsms24:"",
        auditcheckliststatustwoohsms25:"C",
        remarkauditchecklisttwoohsms25:"",
        auditcheckliststatustwoohsms26:"C",
        remarkauditchecklisttwoohsms26:"",

       

    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("values", values)
        mutation.mutate(values)
    }
    const validationSchema = Yup.object({
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/stage2auditreport14001', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Stage 2 Audit Report Data Added')
                //history.push("/" + localStorage.getItem("role") + '/viewauditteamproposal/' + data.data.response.orgCode);
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues", tempInitialValues)
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.auditdate1 = Date.parse(data.data.response.auditdate1) || null;
                tempInitialValues.auditdate2 = Date.parse(data.data.response.auditdate2) || null;
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.auditorOne = data.data.response.auditorOne || "";
                tempInitialValues.auditorTwo = data.data.response.auditorTwo || "";
                tempInitialValues.technicalexpert = data.data.response.technicalexpert || "";

                tempInitialValues.auditcheckliststatustwoohsms1 = data.data.response.auditcheckliststatustwoohsms1 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms1 = data.data.response.remarkauditchecklisttwoohsms1 || "";
                tempInitialValues.auditcheckliststatustwoohsms2 = data.data.response.auditcheckliststatustwoohsms2 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms2 = data.data.response.remarkauditchecklisttwoohsms2 || "";
                tempInitialValues.auditcheckliststatustwoohsms3 = data.data.response.auditcheckliststatustwoohsms3 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms3 = data.data.response.remarkauditchecklisttwoohsms3 || "";
                tempInitialValues.auditcheckliststatustwoohsms4 = data.data.response.auditcheckliststatustwoohsms4 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms4 = data.data.response.remarkauditchecklisttwoohsms4 || "";
                tempInitialValues.auditcheckliststatustwoohsms5 = data.data.response.auditcheckliststatustwoohsms5 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms5 = data.data.response.remarkauditchecklisttwoohsms5 || "";
                tempInitialValues.auditcheckliststatustwoohsms6 = data.data.response.auditcheckliststatustwoohsms6 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms6 = data.data.response.remarkauditchecklisttwoohsms6 || "";
                tempInitialValues.auditcheckliststatustwoohsms7 = data.data.response.auditcheckliststatustwoohsms7 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms7 = data.data.response.remarkauditchecklisttwoohsms7 || "";
                tempInitialValues.auditcheckliststatustwoohsms8 = data.data.response.auditcheckliststatustwoohsms8 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms8 = data.data.response.remarkauditchecklisttwoohsms8 || "";
                tempInitialValues.auditcheckliststatustwoohsms9 = data.data.response.auditcheckliststatustwoohsms9 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms9 = data.data.response.remarkauditchecklisttwoohsms9 || "";
                tempInitialValues.auditcheckliststatustwoohsms10 = data.data.response.auditcheckliststatustwoohsms10 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms10 = data.data.response.remarkauditchecklisttwoohsms10 || "";
                tempInitialValues.auditcheckliststatustwoohsms11 = data.data.response.auditcheckliststatustwoohsms11 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms11 = data.data.response.remarkauditchecklisttwoohsms11 || "";
                tempInitialValues.auditcheckliststatustwoohsms12 = data.data.response.auditcheckliststatustwoohsms12 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms12 = data.data.response.remarkauditchecklisttwoohsms12 || "";
                tempInitialValues.auditcheckliststatustwoohsms13 = data.data.response.auditcheckliststatustwoohsms13 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms13 = data.data.response.remarkauditchecklisttwoohsms13 || "";
                tempInitialValues.auditcheckliststatustwoohsms14 = data.data.response.auditcheckliststatustwoohsms14 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms14 = data.data.response.remarkauditchecklisttwoohsms14 || "";
                tempInitialValues.auditcheckliststatustwoohsms15 = data.data.response.auditcheckliststatustwoohsms15 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms15 = data.data.response.remarkauditchecklisttwoohsms15 || "";
                tempInitialValues.auditcheckliststatustwoohsms16 = data.data.response.auditcheckliststatustwoohsms16 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms16 = data.data.response.remarkauditchecklisttwoohsms16 || "";
                tempInitialValues.auditcheckliststatustwoohsms17 = data.data.response.auditcheckliststatustwoohsms17 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms17 = data.data.response.remarkauditchecklisttwoohsms17 || "";
                tempInitialValues.auditcheckliststatustwoohsms18 = data.data.response.auditcheckliststatustwoohsms18 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms18 = data.data.response.remarkauditchecklisttwoohsms18 || "";
                tempInitialValues.auditcheckliststatustwoohsms19 = data.data.response.auditcheckliststatustwoohsms19 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms19 = data.data.response.remarkauditchecklisttwoohsms19 || "";
                tempInitialValues.auditcheckliststatustwoohsms20 = data.data.response.auditcheckliststatustwoohsms20 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms20 = data.data.response.remarkauditchecklisttwoohsms20 || "";
                tempInitialValues.auditcheckliststatustwoohsms21 = data.data.response.auditcheckliststatustwoohsms21 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms21 = data.data.response.remarkauditchecklisttwoohsms21 || "";
                tempInitialValues.auditcheckliststatustwoohsms22 = data.data.response.auditcheckliststatustwoohsms22 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms22 = data.data.response.remarkauditchecklisttwoohsms22 || "";
                tempInitialValues.auditcheckliststatustwoohsms23 = data.data.response.auditcheckliststatustwoohsms23 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms23 = data.data.response.remarkauditchecklisttwoohsms23 || "";
                tempInitialValues.auditcheckliststatustwoohsms24 = data.data.response.auditcheckliststatustwoohsms24 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms24 = data.data.response.remarkauditchecklisttwoohsms24 || "";
                tempInitialValues.auditcheckliststatustwoohsms25 = data.data.response.auditcheckliststatustwoohsms25 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms25 = data.data.response.remarkauditchecklisttwoohsms25 || "";
                tempInitialValues.auditcheckliststatustwoohsms26 = data.data.response.auditcheckliststatustwoohsms26 || "C";
                tempInitialValues.remarkauditchecklisttwoohsms26 = data.data.response.remarkauditchecklisttwoohsms26 || "";

                setInitialValues(tempInitialValues)
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
                }

               

            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of ast Auditor", data.data.response)
                setassitAuditorList(data.data.response)
                
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("Laead Auditor List", data)
            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("data expert",data)
            
            if (data.data.errorCode === 0) {
                console.log("List of Technical Expert",data.data.response)
                setTechnicalExpertList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { orgcode } = useParams()
   
    const { data: orgList, isLoading: companyListLoading } = useQuery(
        'emsstage1auditreport',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesemsstage1audreport14001/' + localStorage.getItem("userCode"), {}))
    
    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' +orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(Rfqdata=>{
            if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.masteragreementStatus === true) {
                var tempData = Rfqdata.data.response
                tempData.dateofaudit = Date.parse(tempData.dateofaudit);
                tempData.auditdate1 = Date.parse(tempData.auditdate1);
                tempData.auditdate2 = Date.parse(tempData.auditdate2);
                setInitialValues(tempData)
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nacecode && tempData.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempData.nacecode)
                }

            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }
        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    if (companyListLoading) return <h1>Loading</h1>
   
    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
           // validationSchema={validationSchema}
           onSubmit={onSubmit}
        >
            {
                formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">

                                                    <div className="formOuterDiv">

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='selectNACECode' type='text' options={orgList.data.response} label='Client Name' name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Site Address' name='siteofaddress' />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='No. of employees' name='total' disabled={true} />
                                                            
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Mobile' name='mobile' disabled={true} />
                                                            <FormikControl control='input' type="text" label='Email' name='email' disabled={true} />
                                                        </div>
                                                        
                                                        <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='Contact Person Name *' name='contactPersonName' />
                                                        {/* <FormikControl control='input' type="text" label='Position *' name='position' /> */}
                                                    </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Scope of Application' name='scope' disabled={true} />
                                                        </div>
                                                        
                                                        
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Team</h5>
                                                        </div>
                                                        
                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor *" options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`,parseInt(e.value))
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control='selectNACECode'  label='Technical Expert'  options={technicalExpertList}   name='technicalexpert'
                                                                     onChange={(e) => {
                                                                            
                                                                        formik.setFieldValue(`technicalexpert`, e.value)
                                                                        formik.setFieldValue(`technicalExpertName`, e.label)
                                                                    }}
                                                                       
                                                                    values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />
                                                           
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="auditorOne" label='Auditor One' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                                                    formik.setFieldValue(`auditorOneName`, e.label)
                                                                }}
                                                            />
                                                            <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor Two' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorTwo`, e.value)
                                                                    formik.setFieldValue(`auditorTwoName`, e.label)
                                                                }}
                                                            />

                                                        </div>
                                                        
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Mandays</h5>
                                                        </div>


                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label=' Stage 1 Mandays *' name='stageOneAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label=' Stage 1 Audit Date *' name='auditdate1' dateFormat="dd-MM-yyyy"  />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label=' Stage 2 Mandays *' name='stageTwoAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label='  Stage 2 Audit Date *' name='auditdate2' dateFormat="dd-MM-yyyy" />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date Of Audit From' name='dateofaudit' disabled={true}/>
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date Of Audit To' name='dateofauditto' />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Audit Objective' name='auditobjective' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='briefaboutorg' label='Brief about the organization *' />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Verification of the Audit Duration</h5>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Are quoted man-days adequate?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='areqquatedmandays' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in employee detail after application?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangeemployee' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in Scope?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangescope' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any information or Event accrued after the application date which may affect the Man-days?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='isthereanyinforevent' options={options} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit CheckList</h5>
                                                        </div>
                                                        <div className="formRowDiv">
                                                                <div className="col-lg-11">
                                                                    <div class="card mb-4">
                                                        <div class="card-body table-responsive">
                                                            <table className="table table-bordered">
                                                                <thead className="table-primary">
                                                                                <tr>
                                                                                    <th>#</th>
                                                                                    <th scope="col" className="text-center" width="50%">Clause Number</th>
                                                                                    <th scope="col" className="text-center">Status(C/No/O)</th>
                                                                                    <th scope="col" className="text-center">Document Verification detail with statement of Conformity </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-center">1</td>
                                                                                    <td className="fontcontractviewtable">4.1 Understanding the organization and its context (Determination of external and Internal Issues)</td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms1' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms1' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">2</td>
                                                                                    <td className="fontcontractviewtable">4.2 Understanding the needs and expectations of interested parties (Determination, Monitor & Review of the Interested Parties)</td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms2' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms2' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">3</td>
                                                                                    <td className="fontcontractviewtable">4.3 Determining the scope of the OH&S management system 
(documented and having boundaries as well as  considering context of organization and need and expectation or workers and workers and interested parties)

                                                                                    </td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms3' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms3' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">4</td>
                                                                                    <td className="fontcontractviewtable">4.4 OH&S management system 
( established, implement, maintain and continually improve OHSMS )

                                                                                    </td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms4' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms4' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">5</td>
                                                                                    <td className="fontcontractviewtable">5.1 Leadership & Commitment ( Leader shall be from Top Management and have Leadership skill in any other role) </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms5' style={{ textAlign: "center" }} /></td>

                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms5' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">6</td>
                                                                                    <td className="fontcontractviewtable">5.2 OH&S policy ( Documented and communicated and available)
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms6' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms6' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">7</td>
                                                                                    <td className="fontcontractviewtable">5.3 Organizational roles, responsibilities and authorities
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms7' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms7' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">8</td>
                                                                                    <td className="fontcontractviewtable">6.1 Actions to address risks and opportunities (Documented Risk &  opportunities (Documented Risk & opportunities, Consider Hazards, OHS Risk, OHS opportunities and Legal Requirements

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms8' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms8' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">9</td>
                                                                                    <td className="fontcontractviewtable">6.1.2 Hazard identification and assessment of risks and opportunities
(Process mechanism for hazard identification by considering work situation, routine and unroutine matter, past incident, Potential emergency, People and other issues, changes and opportunities

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms9' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms9' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">10</td>
                                                                                    <td className="fontcontractviewtable">6.1.3 Determination of legal requirements and other requirements
(Documented information for legal and other requirements)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms10' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms10' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">11</td>
                                                                                    <td className="fontcontractviewtable">6.1.4 Planning action
( Action to risk and opportunities, legal & other requirements, respond to emergency) 

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms11' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms11' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">12</td>
                                                                                    <td className="fontcontractviewtable">6.2 OH&S objectives and planning to achieve them
(Documented information and plan to achieve objectives and shall determine what, who,  when and how)


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms12' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms12' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">13</td>
                                                                                    <td className="fontcontractviewtable">7.1 Resources (Determine resource requirements for OHSMS)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms13' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms13' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">14</td>
                                                                                    <td className="fontcontractviewtable">7.2 Competence (Documented Information for competence)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms14' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms14' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">15</td>
                                                                                    <td className="fontcontractviewtable">7.3 Awareness (Workers shall made aware OHS policy, Objective, Incident, hazards, risk & opportunities)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms15' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms15' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">16</td>
                                                                                    <td className="fontcontractviewtable">7.4 Communication (documented information of process of communication of internal and external)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms16' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms16' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">17</td>
                                                                                    <td className="fontcontractviewtable">7.5 Documented information (Creation, Identification, Formats, review and approval, distribution, Storage and preservation, retention and disposition and external origin document) 

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms17' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms17' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">18</td>
                                                                                    <td className="fontcontractviewtable">8.1 Operational planning and control 
                                                                                    (Establish, maintain and implemented Process and Plan for operations)


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms18' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms18' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">19</td>
                                                                                    <td className="fontcontractviewtable">8.1.2 Eliminating hazards and reducing OH&S risks
(Establish, maintain and implemented Process for eliminating hazards and reducing the OH & S risks


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms19' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms19' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">20</td>
                                                                                    <td className="fontcontractviewtable">9.1 Monitoring, measurement, analysis and performance evaluation
( documented information for result of monitoring, measurement, analysis and performance evaluation and calibration or verification of measuring equipment)



                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms20' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms20' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">21</td>
                                                                                    <td className="fontcontractviewtable">9.1.2 Evaluation of compliance
(Documented information of the compliance evaluation result)
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms21' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms21' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">22</td>
                                                                                    <td className="fontcontractviewtable">9.2 Internal audit
(Documented information of the Internal Audit Program and audit results)



                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms22' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms22' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">23</td>
                                                                                    <td className="fontcontractviewtable">9.3 Management review
(Documented information of the Management Review results)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms23' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms23' /> </td>
                                                                                </tr>
                                                                                {/* <tr>
                                                                                    <td className="text-center">24</td>
                                                                                    <td className="fontcontractviewtable">10.1 Improvement – General


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms24' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms24' /> </td>
                                                                                </tr> */}
                                                                                <tr>
                                                                                    <td className="text-center">25</td>
                                                                                    <td className="fontcontractviewtable">10.1 Incident, nonconformity and corrective action
(Documented information of the incident or non conformities and  corrective action taken and effectiveness)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms25' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms25' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">26</td>
                                                                                    <td className="fontcontractviewtable">10.2 Continual improvement (Documented information of the Continual Improvement evidence)
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwoohsms26' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwoohsms26' /> </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                    </div>



                                                        
                                                        <div >

                                                            
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>


                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>
                </Form>
            }
        </Formik>
    )
}

export default OhsmsStage2AuditReport